import { SyntheticEvent, useMemo, useState, useEffect } from 'react';
import { onChangeDOM } from '@sdk/types/DOM';

type Props = {
  onSubmitSearch?: (val: string) => void;
  onValueChange?: (val: string) => void;
  onCancelSearch?: () => void;
  submitEager?: boolean;
  initialValue?: string;
};

export const useFoldableSearch = ({
  onSubmitSearch,
  onCancelSearch,
  onValueChange,
  submitEager,
  initialValue,
}: Props) => {
  const [value, setValue] = useState(initialValue || '');
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    setValue(initialValue || '');
  }, [initialValue]);

  const onIconMouseDown = (e: SyntheticEvent) => {
    if (isFocused) {
      e.preventDefault();
    }
  };

  const onChange: onChangeDOM = (e) => {
    setValue(e.target.value);

    if (submitEager) {
      onSubmitSearch?.(e.target.value);
    }

    onValueChange?.(e.target.value);
  };

  const onSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();

    if (submitEager) {
      return;
    }

    if (!value) {
      return;
    }
    onSubmitSearch?.(value);
  };

  const onCancel = () => {
    setValue('');
    onCancelSearch?.();
  };

  const isCancelVisible = useMemo(() => {
    return !!onCancelSearch && !!value.trim();
  }, [onCancelSearch, value]);

  return {
    value,
    isFocused,
    setIsFocused,
    isCancelVisible,
    onIconMouseDown,
    onChange,
    onSubmit,
    onCancel,
  };
};
